import { render, staticRenderFns } from "./SafetyAccidentBasicData.vue?vue&type=template&id=d16ac50e&scoped=true&"
import script from "./SafetyAccidentBasicData.vue?vue&type=script&lang=js&"
export * from "./SafetyAccidentBasicData.vue?vue&type=script&lang=js&"
import style0 from "./SafetyAccidentBasicData.vue?vue&type=style&index=0&id=d16ac50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16ac50e",
  null
  
)

export default component.exports